export enum STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
  ALL = -1,
}

export enum GENDER {
  MALE = 1,
  FEMALE = 0,
}

export const PAGE_SIZES = [20, 50, 100];

export enum NOTIFICATION_OBJECT_TYPE {
  ORDER = 1,
  USER = 2,
}

export enum ATTENDANCE_STATUS {
  NONE = 0, // Không có
  ON_TIME = 1, // Đung giờ
  LATE = 2, // Trễ
  LEAVE_EARLY = 3, // Về sớm
  NOT_CHECKED_IN = 4, // Chưa in
  NOT_CHECKED_OUT = 5, // Chưa checkout
}

export enum ATTENDANCE_ISSUE_TYPE {
  LATE_CHECK_IN = 1,
  EARLY_CHECK_OUT = 2,
  MULTIPLE_CHECK_INS = 3,
}

export enum ABSENCE_TYPE { // Loại vắng mặt
  NONE = 0, // Không vắng mặt
  PERMITTED_PAID = 1, // Có phép - có lương
  PERMITTED_UNPAID = 2, // Có phép - không lương
  UNPERMITTED = 3, // Không phép
  NO_SHIFT = 4, // Không có ca làm
}

export enum CHECK_IN_LOCATION_TYPE {
  OUTSIDE_COMPANY = 1,
  INSIDE_COMPANY = 2,
}

/**
 * Chế độ chấm công ("loại nhân viên") — nguồn sự thật là user service
 * (user/src/database/entities/enums/attendance-mode.enum.ts). Gán 2 tầng: bộ phận
 * (departments.default_attendance_mode, luôn có giá trị) → cá nhân (users.attendance_mode,
 * nullable — null = kế thừa bộ phận).
 */
export enum ATTENDANCE_MODE {
  SHIFT = 1, // Chấm công theo ca — NV chi nhánh / sản xuất
  FIXED = 2, // Giờ làm cố định, không xếp ca — NV văn phòng / trụ sở
  NO_ATTENDANCE = 3, // Không chấm công — quản lý cấp cao, tài xế, NV kiểm đếm
  PART_TIME = 4, // Chấm công part-time — NV sản xuất/chi nhánh bán thời gian (05:00 - 22:00)
}

export const ATTENDANCE_MODE_LABEL: Record<ATTENDANCE_MODE, string> = {
  [ATTENDANCE_MODE.SHIFT]: "Theo ca",
  [ATTENDANCE_MODE.FIXED]: "Giờ hành chính (cố định)",
  [ATTENDANCE_MODE.NO_ATTENDANCE]: "Không chấm công",
  [ATTENDANCE_MODE.PART_TIME]: "Partime",
};

export const ATTENDANCE_MODE_OPTIONS = [
  { value: ATTENDANCE_MODE.SHIFT, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.SHIFT] },
  { value: ATTENDANCE_MODE.FIXED, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.FIXED] },
  { value: ATTENDANCE_MODE.NO_ATTENDANCE, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.NO_ATTENDANCE] },
  { value: ATTENDANCE_MODE.PART_TIME, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.PART_TIME] },
];

export const ATTENDANCE_MODE_FILTER_OPTIONS = [
  { value: 0, label: "Theo bộ phận (mặc định)" },
  { value: ATTENDANCE_MODE.SHIFT, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.SHIFT] },
  { value: ATTENDANCE_MODE.FIXED, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.FIXED] },
  { value: ATTENDANCE_MODE.NO_ATTENDANCE, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.NO_ATTENDANCE] },
  { value: ATTENDANCE_MODE.PART_TIME, label: ATTENDANCE_MODE_LABEL[ATTENDANCE_MODE.PART_TIME] },
];
